import { useRef } from "react"
import { HexAlphaColorPicker, HexColorInput, HexColorPicker } from "react-colorful"

const withVisibleAlpha = (color: string) =>
    color.length === 9 && color.endsWith("00") ? `${color.slice(0, 7)}01` : color

export const ColorPicker = ({
    selectedColor,
    setSelectedColor,
    debounceMs = 50,
    allowAlpha = true,
}: {
    selectedColor: string
    setSelectedColor: (color: string) => void
    debounceMs?: number
    allowAlpha?: boolean
}) => {
    const Picker = allowAlpha ? HexAlphaColorPicker : HexColorPicker
    const debounceTimeout = useRef<ReturnType<typeof setTimeout>>(undefined)

    const updateColor = (color: string) => {
        clearTimeout(debounceTimeout.current)
        debounceTimeout.current = setTimeout(
            () => setSelectedColor(withVisibleAlpha(color)),
            debounceMs
        )
    }

    return (
        <div className="flex flex-col !rounded-none transform z-10">
            <section className="react-colorful__last-control">
                <Picker
                    color={selectedColor}
                    onChange={updateColor}
                    className="rounded-b-none react-colorful__last-control"
                />
            </section>

            <HexColorInput
                color={selectedColor}
                onChange={updateColor}
                prefixed
                placeholder="Add a hex code"
                alpha={allowAlpha}
                className="bg-gray-700 rounded-b-lg text-white py-1 text-center focus:outline-none"
            />
        </div>
    )
}
